const USER_HISTORY = 'user-history';
const IP_HISTORY = 'ip-history';
const SPOT_HISTORY = 'spot-history';
const CONVERSATION = 'conversation';
const SPOT = 'spot';
const TEXT = 'text';

var VIEW_TYPE = {
  USER_HISTORY,
  IP_HISTORY,
  SPOT_HISTORY,
  CONVERSATION,
  SPOT,
  TEXT
};

export const SPAM = 'spam';
export const RESTRICTED_WORDS = 'restricted_words';
export const REJECTED_WORDS = 'rejected_words';
export const PUBLISH_AND_MODERATE_WORDS = 'publish_and_moderate_words';
export const INVALID_CHARACTERS = 'invalid_characters';

//Google Perspective API tags
export const GOOGLE_PERSPECTIVE = 'google_perspective';
export const ATTACK_ON_AUTHOR = 'attack_on_author';
export const ATTACK_ON_COMMENTER = 'attack_on_commenter';
export const FLIRTATION = 'flirtation';
export const IDENTITY_ATTACK = 'identity_attack';
export const INCOHERENT = 'incoherent';
export const INFLAMMATORY = 'inflammatory';
export const INSULT = 'insult';
export const LIKELY_TO_REJECT = 'likely_to_reject';
export const OBSCENE = 'obscene';
export const PROFANITY = 'profanity';
export const SEVERE_TOXICITY = 'severe_toxicity';
export const SEXUALLY_EXPLICIT = 'sexually_explicit';
export const THREAT = 'threat';
export const TOXICITY = 'toxicity';
export const UNSUBSTANTIAL = 'unsubstantial';

var Status = {
  PENDING: 'pending',
  APPROVED: 'approved',
  BLOCKED: 'blocked',
  ALL: 'all',
  OTHER: 'other'
};

var SORT_BY = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
  RELEVANCE: 'relevance'
};

var Permissions = {
  OWNER: 'admin',
  MODERATOR: 'moderator'
};

export { Status, SORT_BY, Permissions, VIEW_TYPE };
